import Loans from '../../src/assets/Loans_128.png';
import Profile from '../../src/assets/profile.png';
import CargoFl from '../../src/assets/cargofl.png';
import { PATHS } from '../Utils/constants';

export const PILET_NAMES = {
  PAYMENTS: 'payments',
  LOGIN: 'login',
  GAMIFICATION: 'gamification',
  EKYC: 'ekyc',
  CARGO_FL: 'cargoFl',
  FINTECH: 'Loans',
  PROFILESDK: 'Profile',
  TRADERUI: 'TraderUI',
  SUVIT: 'suvit',
  MY_CUSTOMERS: 'Customers',
  ON_BEHALF_LOAN: 'On Behalf of Loan',
  COMMERCE: 'COMMERCE',
  NINJAPAY: 'ninjapay',
  NINJAPAY_TEST: 'ninjapay test',
  LENDING_FLOW: 'Lending flow',
  REGISTRATION: 'registration'
};

export const NON_PROFILE_APPS = [
  // PILET_NAMES.CARGO_FL,
  PILET_NAMES.NINJAPAY,
  PILET_NAMES.NINJAPAY_TEST
];

export const pilets = [
  // {
  //   name: PILET_NAMES.PAYMENTS,
  //   spec: `v2`,
  //   link: process.env.PAYMENTS
  // },

  /* {
    name: PILET_NAMES.CARGO_FL,
    spec: `v2`,
    link: process.env.CARGO_FL
  }, */
  {
    name: PILET_NAMES.EKYC,
    spec: `v2`,
    link: process.env.EKYC
  },
  {
    name: PILET_NAMES.LOGIN,
    link: process.env.LOGIN,
    // link: 'http://192.168.29.79:8080/index.js',
    spec: `v2`
  },
  {
    name: PILET_NAMES.NINJAPAY,
    link: process.env.PAYMENTS,
    spec: `v2`
  }
  // PAYMENTS="http://192.168.1.238:8080/index.js"
  // {
  //   name: PILET_NAMES.GAMIFICATION,
  //   link: `https://s3.ap-south-1.amazonaws.com/containerapp.ninjacart.in/bundles/gamification/dist/index.js`,
  //   // link: `http://127.0.0.1:8080/index.js`,
  //   spec: `v2`,
  // },
  // {
  //   name: PILET_NAMES.EKYC,
  //   link: `https://s3.ap-south-1.amazonaws.com/containerapp.ninjacart.in/bundles/ekyc/dist/index.js`,
  //   // link: `http://127.0.0.1:8081/index.js`,
  //   spec: `v2`,
  // },
  // {
  //   name: PILET_NAMES.CARGO_FL,
  //   spec: `v2`,
  //   link: `https://s3.ap-south-1.amazonaws.com/containerapp.ninjacart.in/bundles/cargoFl/dist/index.js`,
  // },
];

export const nonPiletInstances = [
  // {
  //   appId: PILET_NAMES.LENDING_FLOW,
  //   appName: PILET_NAMES.LENDING_FLOW,
  //   path: `loans`,
  //   url: process.env.LOANS,
  //   image: Loans,
  //   imageStyles: {
  //     padding: `5px`
  //   }
  // },
  {
    appId: PILET_NAMES.FINTECH,
    appName: PILET_NAMES.FINTECH,
    path: `loans`,
    // url: `https://freewheel.ninjacart.in/loans`,
    // url: `http://localhost:3000/loans`,
    url: process.env.LOANS,
    image: Loans,
    imageStyles: {
      padding: `5px`
    }
  },
  {
    appId: PILET_NAMES.PROFILESDK,
    appName: PILET_NAMES.PROFILESDK,
    link: `/profile`, // Route
    // url: `http://profile-qa.ninjacart.in`,
    // url: `http://localhost:54235/`,
    url: process.env.PROFILE,
    image: Profile,
    imageStyles: {
      padding: `5px`
    },
    path: `profile?navigate=Profile`
  },
  /* {
    appId: PILET_NAMES.CARGO_FL,
    appName: PILET_NAMES.CARGO_FL,
    image: CargoFl,
    imageStyles: {
      padding: `5px`
    },
    path: '/CargoFL'
  }, */
  // {
  //   appId: PILET_NAMES.COMMERCE,
  //   appName: PILET_NAMES.COMMERCE,
  //   link: `/profile`, // Route
  //   // url: `http://profile-qa.ninjacart.in`,
  //   url: ` http://localhost:61003`,
  //   image: Profile,
  //   imageStyles: {
  //     padding: `5px`,
  //   },
  //   path: `profile?navigate=Home`,
  // },
  {
    appId: PILET_NAMES.TRADERUI,
    appName: PILET_NAMES.TRADERUI,
    path: `/trader-app`, // Route
    url: process.env.TRADER_UI,
    // url: `http://localhost:4200/`,
    image: Profile,
    imageStyles: {
      padding: `5px`
    }
  },
  {
    appId: PILET_NAMES.ON_BEHALF_LOAN,
    appName: PILET_NAMES.ON_BEHALF_LOAN,
    path: `/my-customers?onbehalfofloan=true`, // Route
    // url: `https://freewheel.ninjacart.in/dummy/`,
    url: process.env.FREEWHEEL,
    image: Profile,
    imageStyles: {
      padding: `5px`
    }
  }
  // {
  //   appId: PILET_NAMES.MY_CUSTOMERS,
  //   appName: PILET_NAMES.MY_CUSTOMERS,
  //   path: `/my-customers`, // Route
  //   // url: `https://freewheel.ninjacart.in/dummy/`,
  //   url: `http://localhost:63787`,
  //   image: Profile,
  //   imageStyles: {
  //     padding: `5px`
  //   }
  // },
  // {
  //   appId: `cargoFl`,
  //   appName: `CargoFl`,
  //   image: CargoFl,

  //   url: `https://cargofl.com/trucker`
  // },
  // {
  //   appId: PILET_NAMES.SUVIT,
  //   image: Suvit,
  //   appName: PILET_NAMES.SUVIT,
  //   styles: {
  //     backgroundColor: `#ffffff`,
  //   },
  //   url: `https://suvit.io`,
  // },
  // {
  //   appId: `Dunzo1`,
  //   path: `Dunzo1`,
  //   appName: `Dunzo1`,
  //   url: `https://www.Dunzo.com`,
  //   image: `https://picsum.photos/seed/picsum/200/300`,
  //   imageStyles: {
  //     padding: `5px`
  //   }
  // },
  // {
  //   appId: `CargoFL`,
  //   path: `CargoFL`,
  //   appName: `CargoFL`,
  //   url: `https://www.cargofl.com`,
  //   image: `https://cargofl.com/static/landing/images/logo.png`,
  //   imageStyles: {
  //     padding: `5px`
  //   }
  // },
  // {
  //   appId: `Ninjacart`,
  //   path: `Ninjacart`,
  //   appName: `Ninjacart`,
  //   url: `https://www.ninjacart.in`,
  //   image: `https://ninjacart.in/images/logo.png`,
  //   imageStyles: {
  //     padding: `5px`
  //   }
  // },
  // {
  //   appId: `TestProvider`,
  //   path: `TestProvider`,
  //   appName: `TestProvider`,
  //   url: `https://www.test.in`,
  //   image: `https://picsum.photos/seed/picsum/200/300`,
  //   imageStyles: {
  //     padding: `5px`
  //   }
  // },
  // {
  //   appId: `Gimbook`,
  //   path: `Gimbook`,
  //   appName: `Gimbook`,
  //   url: `https://www.gimbooks.com/web/login/`,
  //   image:
  //     `https://gimbooks.com/blog/content/images/size/w2000/2021/07/banner2.png`,
  //   imageStyles: {
  //     padding: `5px`
  //   }
  // }
];
